import { Deserializer } from './deserializable.model';

export class Base extends Deserializer {
    constructor(json?: Object) {
        super(json);
    }

    getAsJson() {
        let json = {};
        Object.keys(this).forEach(prop => {
            if (this[prop] instanceof Base) {
                // recursive behaviour
                json[prop] = this[prop].getAsJson();
            }
            else {
                // normal behaviour
                json[prop] = this[prop];
            }
        });
        return json;
    }

    // return shallow copy as json
    slice() {
        return this.getAsJson();
    }
    toString(): string {
        return JSON.stringify(this.getAsJson());
    }

    // Compara 2 objetos. Objeto 1: datos entrada (JSON).
    // Objeto 2: Estructura similar con datos defaults
    // Regresa un objeto con la estructura del Objeto 2
    // y los datos del Objeto 1.
    // Si falta algun dato (null) lo sustituye por el valor default del Objeto 2.
    pick(value: Object) {
        let result = {};
        function picker(val, ks, from): Object {
            let res = {};
            ks.forEach((key) => {
                if (from == null) {
                    res[key] = value[key] || '';
                }
                else {
                    if (from[key] == null || val[key] == null) {
                        res[key] = from[key] || value[key] || '';
                    }
                    else if (from.hasOwnProperty(key)) {
                        if (val[key].constructor === Object) {
                            // recursive behaviour
                            res[key] = picker(val[key], Object.keys(val[key]), from[key]);
                        }
                        else {
                            // normal behaviour
                            res[key] = from[key];
                        }
                    }
                }
            });
            return res;
        }
        return picker(value, Object.keys(value), this);
    }

    in_array($valor, $array, $prop = null) {
        let array = $array;
        let valor = $valor;
        for (let i = 0; i < array.length; i++) {
            if (valor == (($prop) ? array[i][$prop] : array[i])) {
                return true;
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/base.ts